export default "__VITE_ASSET__Dhih_8WU__"